import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MacUserService } from '../../services/user/mac-user.service';
import { Router } from '@angular/router';
import packageInfo from '../../../../package.json';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs';
import { ApiServiceInterface, FormServiceInterface, OfflineQueue, OfflineServiceInterface, UserAccountInterface } from '@hutsix/ngxh6';
import { ToastService } from '@hutsix/ngxh6';

@Component({
    selector: 'app-navbar',
    templateUrl: './navbar.component.html',
    styleUrls: ['./navbar.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class NavbarComponent {
    public env: string = environment.env;
    public version: string = packageInfo.version + (environment.env === 'staging' ? '-staging' : '');
    public _user: { loggedIn: boolean; account?: UserAccountInterface };
    public offlineQueue$: Observable<OfflineQueue[]>;

    constructor(
        @Inject('UserService') public userService: MacUserService,
        @Inject('FormService') public formService: FormServiceInterface,
        @Inject('OfflineService') public offline: OfflineServiceInterface,
        @Inject('ApiService') public api: ApiServiceInterface,
        public router: Router,
        public toastr: ToastService,
    ) {
        this.offlineQueue$ = this.offline.getOfflineQueue();
    }

    update(): void {
        this.offlineQueue$ = this.offline.getOfflineQueue();
    }

    clearCaches(): void {
        if (!confirm('All cached data will be removed. You will be required to re-sync to use offline capabilities. Are you sure?')) return;

        this.api.clearCaches().subscribe(res => {
            // Release any stuck offline-sync lock so the UI un-dims and re-sync works.
            this.userService.offline_lock = false;
            this.userService.offlineSyncing = false;
            if (res) {
                this.toastr.success('Caches cleared!');
            } else {
                this.toastr.error('Try again.', 'Something went wrong.');
            }
        });
    }
}
